/**
 * @generated SignedSource<<daad714e8efef50164988ca207c26ace>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type GraphIntegrationSkillColor = "BLUE" | "DEFAULT" | "GRAY" | "GREEN" | "LIME" | "MAGENTA" | "ORANGE" | "PURPLE" | "RED" | "TEAL" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef$data = {
  readonly graphIntegration_componentDirectoryItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "GraphIntegrationSkillDirectoryItem";
        readonly color: GraphIntegrationSkillColor | null;
        readonly description: string | null;
        readonly iconUrl: string | null;
        readonly id: string;
        readonly integrationKey: {
          readonly displayName: string;
          readonly iconUrl: string | null;
        } | null;
        readonly name: string;
        readonly slashCommand: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    }>;
    readonly error: {
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly message: string | null;
    } | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null;
    };
  } | null;
  readonly " $fragmentType": "browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef";
};
export type browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef$key = {
  readonly " $data"?: browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef">;
};

import browseSkillsPaginationQuery_graphql from './browseSkillsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "graphIntegration_componentDirectoryItems"
],
v1 = {
  "kind": "ScalarField",
  "name": "iconUrl"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dimensionIds"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": [
        "SKILL"
      ],
      "kind": "LocalArgument",
      "name": "relevantFor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchKeyword"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "surface"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": browseSkillsPaginationQuery_graphql
    }
  },
  "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef",
  "selections": [
    {
      "alias": "graphIntegration_componentDirectoryItems",
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "dimensionIds",
          "variableName": "dimensionIds"
        },
        {
          "kind": "Variable",
          "name": "relevantFor",
          "variableName": "relevantFor"
        },
        {
          "kind": "Variable",
          "name": "searchKeyword",
          "variableName": "searchKeyword"
        },
        {
          "kind": "Variable",
          "name": "surface",
          "variableName": "surface"
        }
      ],
      "concreteType": "GraphIntegrationDirectoryItemConnection",
      "kind": "LinkedField",
      "name": "__browseSkills_graphIntegration_componentDirectoryItems_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphIntegrationDirectoryItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "id"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "slashCommand"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "description"
                    },
                    (v1/*: any*/),
                    {
                      "concreteType": "GraphIntegrationDirectoryFilterDimension",
                      "kind": "LinkedField",
                      "name": "integrationKey",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "displayName"
                        },
                        (v1/*: any*/)
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "color"
                    }
                  ],
                  "type": "GraphIntegrationSkillDirectoryItem"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "hasPreviousPage"
            },
            {
              "kind": "ScalarField",
              "name": "startCursor"
            },
            {
              "kind": "ScalarField",
              "name": "endCursor"
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "error",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            },
            {
              "kind": "LinkedField",
              "name": "extensions",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "statusCode"
                },
                {
                  "kind": "ScalarField",
                  "name": "errorType"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "f1550383dab3fd9239986448282e14e9";

export default node;
